var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-hr",class:{ 'no-hr-padding': _vm.noHrPadding }},[_c('hr',{attrs:{"color":"#DCDDDE"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }